import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';

export const CountryDisplayWrapper = styled.div`
  ${variants('variant', {
    light: css`
      > p {
        color: ${th('colors.white')};
      }
    `,
    dark: css`
      > p {
        color: ${th('colors.black')};
      }
    `,
    azureWhite: css`
      > p {
        color: ${th('colors.azureWhite')};
      }
    `
  })}

  display: flex;
  align-items: center;

  > p {
    margin-left: 4px;
  }
`;
